<!-- components/LanguageSwitcher.vue -->
<script setup lang="ts">
import { watch } from 'vue'
//import { getTables } from '@/composables/useTabulator'
const { locale, setLocale } = useI18n()
const isOpen = ref(false)
const config = useRuntimeConfig();
const isVisible = ref(config.public.useLocalization == 'true' ? true:false)
// Available languages
const languages = [
  { code: 'en', name: 'English', flag: 'us' },
  { code: 'es', name: 'Español', flag: 'es' },
]
// Switch language
function switchTo(lang: any) {
  setLocale(lang)
  isOpen.value = false
}


</script>

<template >
  <div v-show="isVisible" class="relative inline-block text-left">
    <!-- Button to toggle dropdown -->
    <button
      @click="isOpen = !isOpen"
      class="inline-flex items-center justify-center gap-2 px-3 py-2 rounded hover:bg-white/50 dark:hover:bg-white/50 hover:text-black transition"
    >
      <span :class="`fi fi-${languages.find(l => l.code === locale)?.flag}`"></span>
      {{ locale.toUpperCase() }}
      <svg class="w-4 h-4 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
          d="M19 9l-7 7-7-7" />
      </svg>
    </button>

    <!-- Dropdown menu opens UP -->
    <div
      v-if="isOpen"
      class="absolute right-0 bottom-full mb-2 w-32 bg-white dark:bg-white border border-gray-200 rounded shadow-lg z-50 text-black"
    >
      <ul>
        <li v-for="lang in languages" :key="lang.code">
          <button
            @click="switchTo(lang.code)"
            class="w-full text-left px-3 py-2 flex items-center gap-2 hover:bg-white dark:hover:bg-white transition text-black"
          >
            <span :class="`fi fi-${lang.flag}`"></span>
            {{ lang.name }}
          </button>
        </li>
      </ul>
    </div>
  </div>
</template>


<style scoped>
/* Optional: adjust flag size */
.fi {
  width: 1.25rem;
  height: 1.25rem;
}
</style>